{
    "headingText": "Academic calendar",
    "subHeadingTxt": "academic calendar",
    "currentYearText": "(Current year)",
    "selectAcademicYear": "Select academic year",
    "chooseAcademicYear": "Choose academic year",
    "labelCalendarName": "Calendar name",
    "labelStartDate": "Start Date",
    "labelEndDate": "End Date",
    "createEventBtnText": "Create event",
    "createEventTopBtnText": "Create Event",
    "getApiErrorMessage": "Unable to fetch the data",
    "eventDetails": "Event details",
    "popupHeadingText": "Add Event",
    "academicEventName": "Event name",
    "requiredParam": "*",
    "academicEventNamePlaceholder": "Please enter event name",
    "requiredacademicEventName": "Event name is required and it contains min. 3 characters",
    "maxAcademicEventName": "Maximum 200 characters is allowed",
    "invalidTitle": "Please provide valid data",
    "invalidDescription":"Please provide valid description",
    "eventDescriptionText": "Description",
    "minDescriptionLimit": "Description must be at least 5 characters long",
    "maxDescriptionLimit": "Description cannot exceed 500 characters",
    "startDate": "Start Date",
    "endDate": "End Date",
    "dateValidation": "Start date cannot be after the end date",
    "startDateValidationMessage": "Start date cannot be less then academic start date",
    "endDateValidationMessage": "End date cannot be after the academic end date",
    "selectClasses": "Select classes",
    "classesSelectedLabel": "{0} classes selected",
    "closeText": "CLOSE",
    "deleteHeadingModal": "Delete event",
    "deleteParagraph": "Are you sure you want to delete this event ?",
    "editText": "Update",
    "createText": "Create",
    "pleaseSelectClassesPlaceholder": "Please select classes",
    "selectAll": "Select All",
    "deleteText": "DELETE",
    "selectStaff": "Select staff",
    "pleaseSelectStaffPlaceholder": "Please select staff",
    "staffSelectedLabel": "{0} staff selected",
    "selectCategory": "Select event category",
    "pleaseSelectEventCategory": "Please select event category",
    "eventCreateSuccessText": "Event has been created successfully",
    "eventEditSuccessText":"Event has been edited successfully",
    "unableCreateErrorText": "Unable to create event",
    "eventDetailsText": "Event details",
    "editFeatureText": "EDIT",
    "deleteEventSuccessfull": "Event has been deleted successfully",
    "deleteAcademicEventError": "Unable to delete academic event",
    "publishText": "Publish",
    "unableEditErrorText": "Unable to edit academic event",
    "unableToPublishCalendarErrorMessage": "Unable to publish academic calendar",
    "confirmationPublishText": "Confirm Publish",
    "confirmPublishMessage": "Are you sure you want to publish this academic calendar ?",
    "publishCalendarSuccess": "Academic calendar published successfully",
    "allEventCategoryId": "All",
    "eventType": "Please select event type",
    "fullAcademicType" :"fullAcademicType",
    "SelectEvent" :"Select Event Type",
    "fullAcademic":"Full Academic Year",
    "repeat" : "Repeat",
    "custom" :"Custom",
    "recurringEvent" : "Are you sure you want to delete all recurring events ?",
    "startTimeValidationMessage": "Start time is required and must be valid.",
    "endTimeValidationMessage": "End time must be after the start time.",
    "endTime" :"End Time",
    "startTime" :"Start Time",
    "month":"Month",
    "week" :"Week",
    "day" :"Day",
    "eventInfoHeading": "Event info",
    "addCategoryBtnText": "Add category",
    "eventCategoryPlaceholder": "Please enter category name",
    "CategoryFailedToCreateErrorText": "Unable to create event category"
}